var chunkToChildrenMap = {
	"5268": [
		5522,
		5449,
		8384,
		6443,
		4754,
		2492,
		1770,
		9681,
		6405,
		2106
	],
	"8478": [
		5522,
		5449,
		8384,
		6443,
		4754,
		2492,
		1770,
		9062,
		4086,
		9454,
		1222
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));